(function () {
  const MODAL_ID = 'sm-size-guide-modal';
  const CONTENT_ID = 'sm-size-guide-content';

  // Pick your default guide page here.
  // If you are now using /pages/size-chart, set it as the default.
  const DEFAULT_PAGE_PATH = '/pages/size-chart';

  // Modal on desktop, normal navigation on mobile.
  const USE_MODAL_MIN_WIDTH = 768; // px

  function isDesktop() {
    return window.matchMedia && window.matchMedia(`(min-width: ${USE_MODAL_MIN_WIDTH}px)`).matches;
  }

  function getModal() {
    return document.getElementById(MODAL_ID);
  }

  function getContent() {
    return document.getElementById(CONTENT_ID);
  }

  function openModal(modal, opener) {
    if (!modal) return;
    if (typeof modal.open === 'function') {
      modal.open(opener || null);
      return;
    }
    modal.setAttribute('open', '');
    modal.classList.add('open');
  }

  function handleize(value) {
    return (value || '')
      .toString()
      .toLowerCase()
      .trim()
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');
  }

  function normalizeAnchor(anchor) {
    if (!anchor) return '';
    const a = anchor.toString().trim();
    if (!a) return '';
    return a[0] === '#' ? a : `#${a}`;
  }

  function safeCssEscape(value) {
    if (typeof CSS !== 'undefined' && typeof CSS.escape === 'function') return CSS.escape(value);
    return value.replace(/([ #;?%&,.+*~'"!^$\[\]()=>|\/:\\])/g, '\\$1');
  }

  function scrollToAnchor(container, anchor) {
    if (!container) return;
    const a = normalizeAnchor(anchor);
    if (!a) return;

    const id = a.slice(1);
    const sel = `#${safeCssEscape(id)}`;
    const target = container.querySelector(sel);
    if (target && typeof target.scrollIntoView === 'function') {
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }

  function getFitValue(btn, fitOptionName) {
    if (!fitOptionName) return '';

    // Try within closest variant-picker first
    const picker = btn.closest('variant-picker') || btn.closest('form') || document;
    if (!picker) return '';

    // Symmetry often renders option groups with data-option="Option name"
    const optionValue = fitOptionName.toString();
    const optionSel = `[data-option="${safeCssEscape(optionValue)}"]`;
    const optionRoot = picker.querySelector(optionSel);
    if (!optionRoot) return '';

    const checkedRadio = optionRoot.querySelector('input[type="radio"]:checked');
    if (checkedRadio && checkedRadio.value) return checkedRadio.value;

    const selectedCustomOption = optionRoot.querySelector('.custom-select__option[aria-selected="true"]');
    if (selectedCustomOption) {
      return (selectedCustomOption.getAttribute('data-value') || selectedCustomOption.textContent || '').trim();
    }

    const nativeSelect = optionRoot.querySelector('select');
    if (nativeSelect && nativeSelect.value) return nativeSelect.value;

    return '';
  }

  function buildSectionsUrl(pagePath) {
    const basePath = pagePath || DEFAULT_PAGE_PATH;

    // Keep querystring so theme preview params still work (preview_theme_id, etc.)
    const search = window.location.search || '';
    const joiner = search ? '&' : '?';

    // This must match the section name on the page template.
    // Your current code expects "main". Keep it unless your page template uses a different section handle.
    return `${basePath}${search}${joiner}sections=main`;
  }

  function buildFallbackUrl(pagePath, anchor) {
    const basePath = pagePath || DEFAULT_PAGE_PATH;
    const search = window.location.search || '';
    const a = normalizeAnchor(anchor);
    return `${basePath}${search}${a}`;
  }

  function extractGuide(html) {
    const temp = document.createElement('div');
    temp.innerHTML = html;

    // Grab the actual size guide wrapper if present, else use the section content.
    return temp.querySelector('.sm-size-guide') || temp.firstElementChild || temp;
  }

  function fetchWithTimeout(url, ms) {
    const controller = new AbortController();
    const t = setTimeout(() => controller.abort(), ms);

    return fetch(url, { credentials: 'same-origin', signal: controller.signal })
      .finally(() => clearTimeout(t));
  }

  document.addEventListener('click', function (e) {
    const btn = e.target.closest('[data-sm-size-guide-trigger]');
    if (!btn) return;

    e.preventDefault();

    const fitOptionName = (btn.getAttribute('data-sm-size-guide-fit-option') || '').trim();

    // Start from configured hash (example: "#suits" or "#walking-suits")
    let anchor = normalizeAnchor(btn.getAttribute('data-sm-size-guide-hash') || '');

    // If this is suits, try to map to the correct suits subsection based on selected Fit option
    // Requires your size guide page to have ids like:
    // #suits-regular-fit, #suits-short-fit, #suits-long-fit
    if (anchor && anchor.indexOf('#suits') === 0) {
      const fitValue = getFitValue(btn, fitOptionName);
      if (fitValue) {
        anchor = `#suits-${handleize(fitValue)}`;
      } else {
        anchor = '#suits';
      }
    }

    const pagePath = (btn.getAttribute('data-sm-size-guide-page') || DEFAULT_PAGE_PATH).trim();

    const fallbackUrl = buildFallbackUrl(pagePath, anchor);

    // Mobile: do not use modal. Just navigate.
    // This avoids iOS Safari popup blocking and the stuck Loading state.
    if (!isDesktop()) {
      window.location.href = fallbackUrl;
      return;
    }

    const modal = getModal();
    const content = getContent();

    // If modal markup is missing for some reason, navigate.
    if (!modal || !content) {
      window.location.href = fallbackUrl;
      return;
    }

    content.innerHTML = '<p class="sm-size-guide__loading">Loading…</p>';
    openModal(modal, btn);

    const requestUrl = buildSectionsUrl(pagePath);

    fetchWithTimeout(requestUrl, 8000)
      .then((response) => {
        if (!response.ok) throw new Error('Request failed');
        return response.json();
      })
      .then((data) => {
        const html = data.main || data[Object.keys(data)[0]];
        if (!html) throw new Error('No content');

        const guide = extractGuide(html);

        content.innerHTML = '';
        content.appendChild(guide);

        // Make sure we scroll to the right subsection (suits, suits-regular-fit, etc.)
        scrollToAnchor(content, anchor);
      })
      .catch(() => {
        // Desktop fallback: same tab navigation is most reliable.
        window.location.href = fallbackUrl;
      });
  });
})();
